import BaseService from "./baseService";
import router from "../routes/routes";

class Auth extends BaseService {
  async getUserData(opts = {}) {
    this.endPoint = "/me";

    return this.get(opts);
  }
  logIn(payload) {
    this.endPoint = "/login";
    return this.post(payload);
  }
  logInByGoogle(payload) {
    this.endPoint = "/login-by-google";
    return this.post(payload);
  }
  loggedIn() {
    const authToken = window.localStorage.getItem("access_token");
    return typeof authToken === "string" && authToken.length > 0;
  }
  logOut() {
    window.localStorage.clear();
    window.location.reload(true);
    router.push("/login");
  }
}

export default new Auth();
